module.exports = __webpack_public_path__ + "img/plcconfig_tongxunpeizhi.2b509027.png";